import { NamingConvention } from '.';
import {
  Activity,
  ActivityGroup,
  ActivityMobilisation,
  ActivityStream,
  ActivityStreamInlineCustomData,
  Approver,
  Consumable,
  CustomData,
  CustomDataValue,
  ForecastCategory,
  FreeTextFieldWithValues,
  HiddenSubtab,
  Hse,
  Location,
  LocationCategory,
  OnlineApprover,
  Personnel,
  Progress,
  ProgressWithoutTarget,
  ReportConfiguration,
  StatusTrackerWithData,
  SubprojectConfiguration,
  TableOfColumnWithData,
  Weather,
  WeatherValue,
} from './project-setup';

// TODO(API) remove "list" from fields names once backend rename is done

export interface ProjectSetup {
  activityGroupList: ActivityGroup[];
  activityList: Activity[];
  activityMobilisationList: ActivityMobilisation[];
  activityStreamInlineCustomDataList: ActivityStreamInlineCustomData[];
  activityStreams: ActivityStream[];
  approverList: Approver[];
  consumableList: Consumable[];
  customDataList: CustomData[];
  customDataValueList: CustomDataValue[];
  hiddenSubtabs: HiddenSubtab[];
  hseList: Hse[];
  forecastCategories: ForecastCategory[];
  isReleased: boolean; // TODO(API) replace usage with the flag from the selected subproject, when refactoring the API
  locationCategoryList: LocationCategory[];
  locationList: Location[];
  onlineApproverList: OnlineApprover[];
  freeTextFields: FreeTextFieldWithValues[];
  personnelList: Personnel[];
  progress: Progress;
  progressWithoutTarget: ProgressWithoutTarget;
  tableOfColumns: TableOfColumnWithData[];
  statusTrackers: StatusTrackerWithData[];
  subprojectConfiguration: SubprojectConfiguration;
  weatherList: Weather[];
  weatherDataTypeValueList: WeatherValue[];
  namingConvention: NamingConvention;
  reportConfiguration: ReportConfiguration;
}
